export var STATUS_NAME = Object.freeze({
  REQUESTING_PAYEMENT: 'REQUESTING_PAYEMENT',
  VALIDATED: 'VALIDATED',
  PAID_WAITING_STOCK: 'PAID_WAITING_STOCK',
  ONGOING_PREPARATION: 'ONGOING_PREPARATION',
  DELIVERY_TO_CARRIER: 'DELIVERY_TO_CARRIER',
  DELIVERY_IN_PROGRESS: 'DELIVERY_IN_PROGRESS',
  DELIVERED: 'DELIVERED',
  CANCELED: 'CANCELED',
  VALIDATED_WAITING_STOCK: 'VALIDATED_WAITING_STOCK',
  DELIVERY_TO_CARRIER_DUPLICATED: 'DELIVERY_TO_CARRIER_DUPLICATED',
  APOINTEMENT: 'APOINTEMENT',
  DELIVERED_TO_STORE: 'DELIVERED_TO_STORE',
  DELIVERED_TO_RELAY: 'DELIVERED_TO_RELAY',
  EXCHANGED: 'EXCHANGED',
  REFUNDED: 'REFUNDED',
  PAYMENT_CASH_DESK_ERROR: 'PAYMENT_CASH_DESK_ERROR'
});
export var WITHDRAWED = 'WITHDRAWED';
export var ORDER_STATUS = {
  PAYMENT_REVIEW: 'PAYMENT_REVIEW',
  PROCESSING: 'PROCESSING',
  PAYPAL_REVERSED: 'PAYPAL_REVERSED',
  PAYPAL_CANCELED_REVERSAL: 'PAYPAL_CANCELED_REVERSAL',
  PARTIALLY_COMPLETED: 'PARTIALLY_COMPLETED',
  VALID: 'VALID',
  HOLDED: 'HOLDED',
  FRAUD: 'FRAUD',
  CANCELED: 'CANCELED',
  CLOSED: 'CLOSED',
  COMPLETE: 'COMPLETE'
};
var STATUS = {
  [STATUS_NAME.REQUESTING_PAYEMENT]: {
    id: 0,
    step: 0,
    shipped: false
  },
  [STATUS_NAME.VALIDATED]: {
    id: 1,
    step: 0,
    shipped: true
  },
  [STATUS_NAME.PAID_WAITING_STOCK]: {
    id: 2,
    step: 1,
    shipped: true
  },
  [STATUS_NAME.ONGOING_PREPARATION]: {
    id: 3,
    step: 2,
    shipped: true
  },
  [STATUS_NAME.DELIVERY_TO_CARRIER]: {
    id: 4,
    step: 2,
    shipped: true,
    tracked: true
  },
  [STATUS_NAME.DELIVERY_IN_PROGRESS]: {
    id: 5,
    step: 3,
    shipped: true,
    tracked: true
  },
  [STATUS_NAME.DELIVERED]: {
    id: 6,
    step: 4,
    shipped: false
  },
  [STATUS_NAME.CANCELED]: {
    id: 7,
    step: 4,
    shipped: false
  },
  [STATUS_NAME.VALIDATED_WAITING_STOCK]: {
    id: 8,
    step: 4,
    shipped: false
  },
  [STATUS_NAME.DELIVERY_TO_CARRIER_DUPLICATED]: {
    id: 9,
    step: 4,
    shipped: false
  },
  [STATUS_NAME.APOINTEMENT]: {
    id: 10,
    step: 4,
    shipped: false
  },
  [STATUS_NAME.DELIVERED_TO_STORE]: {
    id: 11,
    step: 4,
    shipped: false
  },
  [STATUS_NAME.DELIVERED_TO_RELAY]: {
    id: 12,
    step: 4,
    shipped: false
  },
  [STATUS_NAME.EXCHANGED]: {
    id: 13,
    step: 4,
    shipped: false
  },
  [STATUS_NAME.REFUNDED]: {
    id: 14,
    step: 4,
    shipped: false
  }
};
var magasinId = 'MAGASIN';
export var isAShop = carrier => carrier.id === magasinId;
export default STATUS;